export const handleScrollGenerator = (id, setPlaying) => {
    let scrollTimeout;
    return () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            const playerContainer = document.getElementById(id);
            const rect = playerContainer.getBoundingClientRect();
            if (rect.top >= window.innerHeight || rect.bottom <= 0) {
              return setPlaying(false);
            } else {
              return setPlaying(true);
            }
        }, 100);
    };
};